import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

import crossIcon from "../../assets/img/icons/cross_black.svg";
import pauseIcon from "../../assets/pause-subscription.svg";
import { openModal } from "./Paddle";
import { createNotification } from "../../utils/notificationManager";

function CancelModal({
  modal,
  setModal,
  cancelURL,
  managePauseSubscription,
  isPaused,
  submitFeedback,
  isLoading,
  actions,
}) {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedback, setFeedback] = useState("");
  const subscriptionActions = actions || {};

  const toggle = () => {
    setModal({
      cancelModal: !modal.cancelModal,
    });
    // Reset form state when modal closes
    setShowFeedbackForm(false);
    setFeedback("");
  };

  const handleCancelAnyway = () => {
    setShowFeedbackForm(true);
  };

  const handleFeedbackSubmit = (e) => {
    e.preventDefault();
    if (feedback.trim()) {
      submitFeedback({ feedback: feedback.trim() });
      setFeedback("");
      setShowFeedbackForm(false);
      setTimeout(() => {
        if (!cancelURL) {
          createNotification(
            "warning",
            "Subscription cancellation link is not available. Please refresh and try again.",
            3000
          );
          return;
        }

        openModal(cancelURL);
      }, 1000);
    }
  };

  return (
    <div>
      <Modal
        isOpen={modal.cancelModal}
        toggle={toggle}
        backdrop={true}
        keyboard={true}
        centered={true}
        size="lg">
        <img loading="lazy"
          src={crossIcon}
          alt="cross"
          className="cross-icon"
          onClick={toggle}
        />

        <ModalBody>
          <div className="cancel-modal-body">
            {!showFeedbackForm ? (
              <>
                <p>
                  {isPaused
                    ? "Your subscription is paused"
                    : "Consider pausing your subscription instead of canceling"}
                </p>
                <p>
                  {isPaused
                    ? "If you want you can resume your subscription and keep using Groupboss."
                    : "Do you know? You can take a break without canceling your subscription and resume once you decide."}
                </p>
                <img loading="lazy"
                  src={pauseIcon}
                  alt=""
                  style={{
                    width: "120px",
                    height: "120px",
                  }}
                />
                <div className="modal-container-box">
                  {subscriptionActions.can_pause !== false && (
                    <button
                      className="pause-button"
                      disabled={isLoading}
                      onClick={() => {
                        const actionPayload = isPaused
                          ? { action: "resume" }
                          : { action: "pause" };
                        managePauseSubscription(
                          actionPayload.action === "resume"
                            ? { pause: false }
                            : { pause: true }
                        );
                        toggle();
                      }}>
                      {!isPaused ? "Pause Subscription" : "Resume Subscription"}
                    </button>
                  )}
                  <button
                    className="cancel-button"
                    disabled={isLoading || subscriptionActions.can_cancel === false}
                    onClick={handleCancelAnyway}>
                    Cancel Subscription Anyway!
                  </button>
                </div>
                {subscriptionActions.blocked_reason && (
                  <p
                    style={{
                      marginTop: "16px",
                      color: "#7a5b00",
                      fontSize: "14px",
                      lineHeight: "1.5",
                    }}
                  >
                    {subscriptionActions.blocked_reason}
                  </p>
                )}
              </>
            ) : (
              <div className="feedback-form" style={{
                textAlign: 'center',
                maxWidth: '500px',
                margin: '0 auto',
                padding: '20px 0'
              }}>
                <h4 style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#2c3e50',
                  marginBottom: '12px',
                  lineHeight: '1.3'
                }}>We're sorry to see you go!</h4>
                <p style={{
                  fontSize: '16px',
                  color: '#6c757d',
                  lineHeight: '1.6',
                  marginBottom: '32px',
                  textAlign: 'center'
                }}>Please tell us why you're canceling. This helps us improve our service and is required to proceed with cancellation.</p>
                
                <form onSubmit={handleFeedbackSubmit} style={{ textAlign: 'left' }}>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Please share your reason for canceling... (Required)"
                      value={feedback}
                      onChange={(e) => setFeedback(e.target.value)}
                      required
                      style={{
                        width: "100%",
                        padding: "16px",
                        border: "2px solid #e9ecef",
                        borderRadius: "12px",
                        resize: "vertical",
                        minHeight: "120px",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        fontFamily: "inherit",
                        transition: "all 0.3s ease",
                        boxSizing: "border-box"
                      }}
                      onFocus={(e) => {
                        e.target.style.outline = "none";
                        e.target.style.borderColor = "#05c7ca";
                        e.target.style.boxShadow = "0 0 0 3px rgba(5, 199, 202, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e9ecef";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                    {!feedback.trim() && (
                      <small style={{ 
                        color: "#dc3545", 
                        fontSize: "13px",
                        marginTop: "8px",
                        display: "block"
                      }}>
                        * Feedback is required to proceed with cancellation
                      </small>
                    )}
                  </div>
                  
                  <div className="modal-container-box" style={{ 
                    marginTop: "24px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    width: "100%"
                  }}>
                                         <button
                       type="submit"
                       className="cancel-button"
                       disabled={isLoading || !feedback.trim()}
                       style={{ 
                         width: "100%",
                         background: "#f4f4f4",
                         color: "#333333",
                         border: "1px solid #f4f4f4",
                         padding: "12px 24px",
                         fontSize: "14px",
                         fontWeight: "500",
                         cursor: isLoading || !feedback.trim() ? "not-allowed" : "pointer",
                         transition: "all 0.2s ease",
                         borderRadius: "3px",
                         opacity: isLoading || !feedback.trim() ? "0.6" : "1"
                       }}
                       onMouseEnter={(e) => {
                         if (!isLoading && feedback.trim()) {
                           e.target.style.background = "#e8e8e8";
                           e.target.style.borderColor = "#e8e8e8";
                         }
                       }}
                       onMouseLeave={(e) => {
                         e.target.style.background = "#f4f4f4";
                         e.target.style.borderColor = "#f4f4f4";
                       }}>
                       {isLoading ? "Submitting..." : "Submit Feedback & Continue"}
                     </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CancelModal;
